import callApi from '../../util/apiCaller';

export const REQUEST_NEWSLETTER_ADD = 'REQUEST_NEWSLETTER_ADD';
export const NEWSLETTER_ADD_SUCCESS = 'NEWSLETTER_ADD_SUCCESS';
export const NEWSLETTER_ADD_FAILURE = 'NEWSLETTER_ADD_FAILURE';

export function sendNewsletterFailedResponse() {
  return {
    type: NEWSLETTER_ADD_FAILURE,
    isRegisteringForNewsletter: false,
  };
}

export function sendNewsletterSuccessResponse() {
  return {
    type: NEWSLETTER_ADD_SUCCESS,
    isRegisteringForNewsletter: false,
  };
}

export function registeringForNewsletter() {
  return {
    type: REQUEST_NEWSLETTER_ADD,
    isRegisteringForNewsletter: true,
  };
}

export function registerNewsletter(creds) {
  return (dispatch) => {
    dispatch(registeringForNewsletter());
    return callApi(`newsletters`, 'post', {
      newsletter: creds,
    }).then(res => {
      if (res.status === 'Success') {
        dispatch(sendNewsletterSuccessResponse());
      } else {
        dispatch(sendNewsletterFailedResponse());
      }
    });
  };
}
